import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from "@angular/material/snack-bar";
import { SharedComponentsModule } from "../components.module";

export interface SuccessSnackbarData {
	message: string;
	userName?: string;
	action?: "create" | "update" | "upload";
	staffNumber?: string;
	folderCategory?: string;
}

@Component({
	selector: "app-success-snackbar",
	template: `
		<div class="success-snackbar-container">
			<mat-icon class="success-icon">check_circle</mat-icon>
			@if (data.action) {
				@switch (data.action) {
					@case ("create") {
						@if (data.userName) {
							User '<span class="username">{{ data.userName }}</span
							>' has been successfully created.
						} @else {
							{{ data.message }}
						}
					}
					@case ("update") {
						@if (data.userName) {
							User '<span class="username">{{ data.userName }}</span
							>' has been successfully updated.
						} @else {
							{{ data.message }}
						}
					}
					@case ("upload") {
						<span class="staff-number">{{ data.staffNumber }}</span> <span class="username">{{ data.userName }}</span
						>/<span class="folder-category">{{ data.folderCategory }}</span>
					}
				}
			} @else {
				{{ data.message }}
			}
		</div>
	`,
	styles: [
		`
			:host {
				display: block;
				width: 100%;
			}

			.success-snackbar-container {
				display: flex;
				align-items: center;
			}

			.success-icon {
				color: #067e41;
				font-size: 20px;
				width: 20px;
				height: 20px;
				flex-shrink: 0;
				margin-right: 12px;
			}

			.success-message {
				font-weight: 400;
				font-size: 14px;
				flex: 1;
			}

			.username {
				font-weight: 700;
			}

			.staff-number {
				font-weight: 700;
			}

			.folder-category {
				font-weight: 700;
			}
		`,
	],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [SharedComponentsModule],
})
export class SuccessSnackbarComponent {
	message: string;

	constructor(
		public snackBarRef: MatSnackBarRef<SuccessSnackbarComponent>,
		@Inject(MAT_SNACK_BAR_DATA) public data: SuccessSnackbarData,
	) {
		this.message = this.getDisplayMessage();
	}

	private getDisplayMessage(): string {
		if (this.data.userName && this.data.action) {
			switch (this.data.action) {
				case "create":
					return `User '${this.data.userName}' has been successfully created.`;
				case "update":
					return `User '${this.data.userName}' has been successfully updated.`;
				case "upload":
					return `${this.data.staffNumber} ${this.data.userName}/${this.data.folderCategory}`;
				default:
					return this.data.message;
			}
		} else if (this.data.userName) {
			return `User '${this.data.userName}' has been successfully created.`;
		}
		return this.data.message;
	}
}
